import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _class, _class2, _descriptor, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "718a6UbDfNFMLtKSJ9HxcxG", "Common", undefined);

import { _decorator, Component, Label } from 'cc';
import { E_EventType } from './common/EnumBase';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Common = (_dec = ccclass('Common'), _dec2 = property(Label), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Common, _Component);

  function Common() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_coin", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = Common.prototype;

  _proto.onLoad = function onLoad() {
    App.GameCtrl.n_coinRoot = this.lbl_coin.node.parent.getChildByName("coinTip");
  };

  _proto.start = function start() {
    // [3]
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
    this.addEventListenr();
    this.handle_conChange();
  };

  _proto.onDestroy = function onDestroy() {
    // GameCtr.I.removeEventListener();
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    //段位经验变化
    App.EventMgr.addEventLintener(E_EventType.Coin_Change, this.handle_conChange, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
  };

  _proto.handle_conChange = function handle_conChange() {
    this.lbl_coin.string = App.DataMgr.coin + "";
  };

  _proto.btn_event = function btn_event(btn) {
    switch (btn.node.name) {
      case "n_set":
        // App.DataMgr.giftPg = 0.88;
        // App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Gift);
        // App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Set);
        break;
    }
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return Common;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "lbl_coin", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();